import {defineStore} from "pinia";
import {ref, computed} from "vue";
import {useFullscreen} from "@vueuse/core";

export const useVideoStore = defineStore("video-store", () => {

    const video = ref(null);
    const fullscreenElement = computed(() => video.value?.player);
    const fullscreen = useFullscreen(fullscreenElement);
    const isFullscreenSupported = ref(fullscreen.isSupported)
    
    // In-memory mute state - always starts muted for autoplay compliance
    // State is only remembered during navigation, not on page refresh
    const globalMuteState = ref(true);
    const userHasInteracted = ref(false);

    const setCurrentVideo = (current) => {
        video.value = current;
        // Apply global mute state to new video if user has previously interacted
        if (current && current.player && userHasInteracted.value) {
            // Handle both old structure (player.value) and new structure (player directly)
            const playerEl = current.player.value || current.player;
            if (playerEl) {
                playerEl.muted = globalMuteState.value;
            }
            // Update state if available
            if (current.state) {
                const state = current.state.value || current.state;
                if (state) {
                    state.muted = globalMuteState.value;
                }
            }
        }
    }
    const toggleModelAudio = () => {
        // Always toggle the global state first
        const newMuteState = !globalMuteState.value;
        setGlobalMuteState(newMuteState);
        
        // Then apply to current video if it exists
        if (video.value && video.value.player) {
            // Handle both old structure (player.value) and new structure (player directly)
            const playerEl = video.value.player.value || video.value.player;
            if (playerEl) {
                playerEl.muted = newMuteState;
            }
            // Update state if available
            if (video.value.state) {
                const state = video.value.state.value || video.value.state;
                if (state) {
                    state.muted = newMuteState;
                }
            }
        }
    }
    
    const setGlobalMuteState = (muted) => {
        globalMuteState.value = muted;
        userHasInteracted.value = true;
        // No persistence - state only lasts during navigation
    }
    
    const getInitialMuteState = () => {
        // Return true (muted) by default, unless user has previously unmuted
        return userHasInteracted.value ? globalMuteState.value : true;
    }
    const toggleFullscreen = () => {
        if (fullscreenElement.value) {
            fullscreen.toggle();
        } else {
            console.warn('Cannot toggle fullscreen, video element not found.');
        }
    }

    // Computed for better reactivity
    const isMuted = computed(() => globalMuteState.value);



    return {
        video,
        isFullscreenSupported,
        globalMuteState,
        userHasInteracted,
        isMuted,
        setCurrentVideo,
        toggleModelAudio,
        toggleFullscreen,
        setGlobalMuteState,
        getInitialMuteState
    };
});
